var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirAirlineLogoAf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 64.67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m106.86 28.14-4.31 6.33c-.57.83-1.49 1.64-2.6 1.72v.19h4.8c1.27 0 2.2-.84 2.83-1.77l4.43-6.48h-5.14z",
    fill: "#e82f17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m27.45 36.39v-7.55h2.17v7.55zm50.06 0-5.22-4.49v4.49h-1.83v-7.55h1.56l5.15 4.42v-4.42h1.83v7.55zm11.35-5.12c-.98-.49-2.09-.89-3.55-.89-1.75 0-3.05.92-3.05 2.2s1.33 2.24 3.04 2.24c1.41 0 2.53-.37 3.64-1.01v1.87c-.97.49-2.27.86-3.73.86-2.98 0-5.32-1.54-5.32-3.95s2.39-3.89 5.31-3.89c1.38 0 2.63.26 3.67.69v1.88zm-47.16 5.12v-7.55h7.26v1.62h-5.09v1.88h4.97v1.62h-4.97v2.44h-2.17zm48.47 0v-7.55h7.53v1.62h-5.36v1.31h5.28v1.62h-5.28v1.39h5.34v1.62h-7.51zm-33.67-2.84 3 2.84h-2.32c-.51 0-.85-.16-1.12-.43l-2.04-2.01s-.11-.07-.18-.06h-1.39v2.5h-2.17v-7.55h4.7c2.44 0 3.47 1.11 3.47 2.34 0 1.43-1.26 2.12-1.96 2.38zm-1.74-1.24c.86 0 1.27-.44 1.27-.94s-.37-.91-1.27-.91h-2.31v1.85zm-16.9 1.24 3 2.83h-2.32c-.51 0-.85-.16-1.12-.43l-2.04-2.01s-.11-.07-.18-.06h-1.39v2.5h-2.17v-7.55h4.7c2.44 0 3.47 1.11 3.47 2.34 0 1.43-1.26 2.12-1.96 2.38zm-1.73-1.24c.86 0 1.27-.44 1.27-.94s-.37-.91-1.27-.91h-2.31v1.85zm-12.08 4.08-.95-1.66h-4.16l-.87 1.66h-2.07l4.14-7.55h1.89l4.69 7.55h-2.68zm-4.28-3.23h2.42l-1.26-2.31-1.17 2.31zm47.63 3.23-.93-1.66h-4.05l-.84 1.66h-2.02l4.03-7.55h1.83l4.56 7.55h-2.6zm-4.17-3.23h2.36l-1.23-2.31-1.14 2.31z",
    fill: "#0d1131"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h128v64.67h-128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 64.67h128v64.67h-128z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirAirlineLogoAf);
export default __webpack_public_path__ + "static/media/air_airline_logo_AF.9568596ab4af461df7ee067d5f9b6320.svg";
export { ForwardRef as ReactComponent };